import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { setAuthorizationToken } from 'services/axios';

import AppLogger from 'utils/AppLogger';

/**
 * Initialize the application with common setup logic
 * @param {Object} options - Initialization options
 * @param {boolean} [options.isSalesChannelRedirect=false] - Whether to check for sales channel redirect
 */
export const initializeApp = () => {
	// Initialize app logger
	AppLogger.init();

	// Setup authentication
	setupAuth();

	// Check for sales channel redirect if the platform is web
	checkSalesChannelRedirect();

	// Configure dayjs
	configureDayjs();

	// Remove the app loader if it exists
	document.getElementById('app-loader')?.remove();
};

// Handle authentication token setup
const setupAuth = () => {
	// Set the access token from the local storage
	const ACCESS_TOKEN = localStorage.getItem('ACCESS_TOKEN');
	if (ACCESS_TOKEN) {
		setAuthorizationToken(ACCESS_TOKEN);
	}

	// This is a mobile app specific code to set the access token from the URL
	if (import.meta.env.VITE_PLATFORM === 'web') {
		const searchParams = new URLSearchParams(window.location.search);
		const CUSTOM_ACCESS_TOKEN = searchParams.get('oto-token');
		if (CUSTOM_ACCESS_TOKEN) {
			localStorage.setItem('ACCESS_TOKEN', CUSTOM_ACCESS_TOKEN);
			setAuthorizationToken(CUSTOM_ACCESS_TOKEN);
		}
	}
};

const checkSalesChannelRedirect = () => {
	if (import.meta.env.VITE_PLATFORM === 'web') {
		if (window.location.pathname.startsWith('/sales-channels') && window.self !== window.top) {
			window.parent?.location.replace(window.location.href);
			AppLogger.log('Redirecting window.parent to ', window.location.href);
		}
	}
};

const configureDayjs = () => {
	dayjs.extend(utc);
	dayjs.extend(timezone);
	dayjs.extend(duration);
	dayjs.extend(customParseFormat);
};
